// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function info(...data: any[]) {
  if (process.env.LOGGER_ENABLED === 'true') {
    console.info(...data);
  }
}
